import {Component} from "preact"
import ToolbarButton from "../../../../../common/toolbar-button";
import ConfigService from "../../../../../../services/ConfigService";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import Toolbar from "../../../../../layout/toolbar";
import ScrollableSection from "../../../../../layout/scrollable-section";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import Text from "../../../../../common/text";
import BookmarkOutlineIcon from "mdi-preact/BookmarkOutlineIcon";
import style from "./styles.scss";
import HelpCircleOutlineIcon from "mdi-preact/HelpCircleOutlineIcon";
import {TranslateService} from "../../../../../../services/TranslateService";
import OpenInNewIcon from "mdi-preact/OpenInNewIcon";

export default class HelpDeskMenu extends Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        onNavigate: () => {
        }
    };


    render(props, state, context) {
        const hasManuals = Array.isArray(ConfigService.manuals()) && ConfigService.manuals().length;
        const helpdeskUrl = ConfigService.helpdeskUrl();

        const manuals = () => (!hasManuals) ? null : (
            <Toolbar>
                <ToolbarButton type={'fill text'} onClick={() => {
                    this.navigateToManuals()
                }}>
                    <BookmarkOutlineIcon style={{color: '#0079B8', margin: '0 1em 0 0.25em'}}/>
                    <Text text={'manuals_dropdown_title'}/>
                </ToolbarButton>
            </Toolbar>
        );

        const helpdesk = () => (!helpdeskUrl || !helpdeskUrl.length) ? null : (
            <Toolbar>
                <a class={style.linkButton} href={helpdeskUrl} target="_blank" onClick={this.navigateToHelpdesk}>
                    <svg style={{fill: '#0079B8', margin: '0 1em 0 .25em'}} class="mdi-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path d="M12.5 24h-1a2.8 2.8 0 01-2.8-2.8v-.5c0-.1 0-.2-.2-.3h-.3l-.4.4a2.8 2.8 0 01-4 0l-.6-.6a2.8 2.8 0 010-4l.3-.4v-.3c0-.1 0-.2-.2-.2h-.5A2.8 2.8 0 010 12.5v-1C0 10 1.3 8.7 2.8 8.7h.5c.1 0 .2 0 .3-.2v-.3l-.4-.4a2.8 2.8 0 010-4l.6-.6a2.8 2.8 0 014 0l.4.3h.3c.1 0 .2 0 .2-.2v-.5C8.7 1.3 10 0 11.5 0h1c1.5 0 2.8 1.3 2.8 2.8v.5c0 .1 0 .2.2.3h.3l.4-.4a2.8 2.8 0 014 0l.6.6a2.8 2.8 0 010 4l-.3.4v.3c0 .1 0 .2.2.2h.5c1.5 0 2.8 1.3 2.8 2.8v1c0 1.3-.9 2.4-2.1 2.7a1 1 0 01-.5-1.8c.4-.1.7-.5.7-1v-.9c0-.5-.4-1-1-1h-.4c-.9 0-1.7-.4-2-1.3-.4-.8-.2-1.7.5-2.4l.3-.3c.2-.2.3-.4.3-.7a1 1 0 00-.3-.6l-.7-.7a1 1 0 00-1.3 0l-.3.3c-.7.7-1.6.9-2.4.5a2.2 2.2 0 01-1.4-2v-.5c0-.5-.4-1-1-1h-.9a1 1 0 00-1 1v.5c0 .9-.4 1.7-1.3 2-.8.4-1.7.2-2.4-.5l-.3-.3a1 1 0 00-1.3 0l-.7.7a1 1 0 000 1.3l.3.3c.7.7.9 1.6.5 2.4-.3.9-1.1 1.4-2 1.4h-.5a1 1 0 00-1 1v.9c0 .5.5 1 1 1h.5c.9 0 1.7.4 2 1.3.4.8.2 1.7-.5 2.4l-.3.3a1 1 0 000 1.3l.7.7a1 1 0 001.3 0l.3-.3c.7-.7 1.6-.9 2.4-.5.9.3 1.4 1.1 1.4 2v.5c0 .5.4 1 1 1h.9c.4 0 .7-.3.9-.7a1 1 0 011.8.5c-.4 1.2-1.5 2-2.7 2zm10.7-.9c.5-.5.8-1.2.8-1.9s-.3-1.4-.8-2l-6-6c.2-.6.4-1.3.4-1.9 0-1.2-.5-2.3-1.4-3.2-1-1-2.7-1.7-4.4-1.7-.6 0-1 0-1.6.3a1 1 0 00-.4 1.5l2.3 2.3-.3 1.2-1.2.3-2.3-2.3a1 1 0 00-1.6.4l-.3 1.6c0 1.4.5 2.8 1.2 3.9 1 1.2 2.3 2 3.8 2 .5 0 1.2-.2 1.9-.5l6 6a2.7 2.7 0 003.9 0zm-10.3-8c-.4.4-1.1.6-1.5.6-1.1 0-1.9-.7-2.3-1.2-.4-.6-.6-1.3-.7-2l1.2 1.2c.2.2.6.3.9.2l2.3-.5c.3 0 .6-.3.7-.7l.5-2.3c0-.3 0-.6-.2-.8l-1.3-1.3c1 .1 1.8.6 2.4 1.1.5.6.8 1.2.8 2 0 .3-.2 1-.5 1.4-.3.4-.2 1 0 1.2l6.7 6.6a.9.9 0 010 1.2.9.9 0 01-1.3 0l-6.5-6.5a1 1 0 00-1.2-.1zm0 0"/></svg>
                    <Text text={'help_desk_link_text'}/>
                    <OpenInNewIcon class={style.linkIcon}/>
                </a>
            </Toolbar>
        );

        return (
            <VerticalUiContainer>
                <Toolbar class={style.toolbar}>
                    <div class={style.iconButton}><HelpCircleOutlineIcon/></div>
                    <ToolbarTitle><Text text={'help_desk_dropdown_title'}/></ToolbarTitle>
                </Toolbar>
                <ScrollableSection>
                    {helpdesk()}
                    {manuals()}
                </ScrollableSection>
            </VerticalUiContainer>
        );
    }

    navigateToManuals = () => {
        this.props.onNavigate('manuals');
    };

    navigateToHelpdesk = (event) => {
        event.preventDefault();
        event.stopPropagation();
        ConfigService.navigateFunction(ConfigService.helpdeskUrl());
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/help-desk/help-desk-menu/index.js